import React from 'react';
import styled from 'styled-components';
import { AlmeAppUtilsBase } from "../../AlmeApp/AlmeAppState";
import IconButton from '../../AlmeUtilities/Icons/IconButton';
import postMessage from '../../../post-message/PostMessageUtils';
import { isRCPostLoginMobile } from '../../../platform/identifiers';
const MinimizeContainer = styled.div `
    display: inline-block;
    margin-right: 15px;
`;
const AlmeMinimize = (props) => {
    if (!props.almeAppConfig.header.isMinimizeEnabled) {
        return null;
    }
    return (React.createElement(MinimizeContainer, null,
        React.createElement(IconButton, Object.assign({ id: 'alme-minimize', className: 'alme--window--header--toolbar--minimize', "aria-label": "minimize", title: "Minimize chat window", iconType: "MinimizeButton", type: "button", size: 20, onClick: props.onMinimizeClick }, props.focusProps))));
};
export default AlmeMinimize;
export class AlmeMinimizeUtils extends AlmeAppUtilsBase {
    onMinimizeClick() {
        this.setAlmeState(Object.assign(Object.assign({}, this.almeState), { isOpen: false }));
        if (this.appConfig.main.platform === "PSCC" || isRCPostLoginMobile()) {
            postMessage({
                type: 'IsMinimized',
                source: 'nit',
            });
        }
        return Promise.resolve();
    }
}
